import Body from './body';
import getErrors from './validation';

export default {
  header: null,
  body: Body,
  settings: null,
  getErrors
};
